import { render, staticRenderFns } from "./SmsErrorModal.vue?vue&type=template&id=457318de&scoped=true"
var script = {}
import style0 from "./SmsErrorModal.vue?vue&type=style&index=0&id=457318de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457318de",
  null
  
)

export default component.exports